import * as types from './types'

export default {
  [types.SET_BUSINESS](state, data) {
    state.business = data
  },
  [types.SET_BUSINESSES](state, data) {
    state.totalBusinesses = 0
    state.businesses = []
    if (data !== undefined && data !== null) {
      state.totalBusinesses = data.total
      for (let item of data.results) {
        item.isChecked = false
      }
      state.businesses = data.results
    }
  },
  [types.SET_SEARCH_BUSINESSES](state, data) {
    state.totalBusinesses = 0
    state.businesses = []
    if (data !== undefined && data !== null) {
      state.totalBusinesses = data.items.length
      for (let item of data.items) {
        item.isChecked = false
      }
      state.businesses = data
    }
  },
  [types.SET_SEARCH_TERM](state, text) {
    if (text !== undefined && text !== null) {
      state.searchTerm = text
    }
  },
  [types.SET_PAGE_SIZE](state, value) {
    if (value !== undefined && value !== null) {
      state.pageSize = parseInt(value)
    }
  },
  [types.SET_SORT_DIR](state, text) {
    if (text !== undefined && text !== null) {
      state.sortDir = text
    }
  },
  [types.SET_ORDER_BY](state, text) {
    if (text !== undefined && text !== null) {
      state.orderBy = text
    }
  },
  [types.SET_STATUS](state, value) {
    if (value !== undefined && value !== null) {
      state.status = value
    }
  },
  [types.SET_FILTER_BY](state, value) {
    if (value !== undefined && value !== null) {
      state.filterBy = parseInt(value)
    }
  },
  [types.CLEAR_BUSINESSES](state) {
    state.businesses = []
  },
  [types.SET_BUSINESS_CHECKED](state, data) {
    for (let business of state.businesses.items) {
      business.isChecked = false
      if (business.sid === data.sid) {
        business.isChecked = data.isChecked
      }
    }
  },
  [types.SET_BUSINESS_CONTACTS](state, data) {
    state.businessContacts = []
    if (data !== undefined && data !== null) {
      for (let item of data) {
        let _contact = item.lastName
        if (item.firstName !== '') {
          _contact += ', ' + item.firstName
        }
        if (item.phone !== '') {
          _contact += ' - ' + item.phone
        }
        state.businessContacts.push({
          name: _contact,
          value: item.id,
          id: item.id,
          firstName: item.firstName,
          lastName: item.lastName,
          phone: item.phone,
          email: item.email
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/businesses/mutations.js